import { DialogTitle, Typography } from "@mui/material";

type Props = {
    title: string;
    onClose: () => void;
};

export const CommentDialogHeader = ({ title, onClose }: Props) => {
    return (
        <DialogTitle
            sx={{
                padding: 0,
            }}
        >
            <Typography variant="huge-bold">{title}</Typography>
        </DialogTitle>
    );
};
